import { render } from "./OrthoSettings.vue?vue&type=template&id=7f7ffad3"
import script from "./OrthoSettings.vue?vue&type=script&lang=js"
export * from "./OrthoSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__